import UpdateUser from '../components/users/update-user/UpdateUser';

const UpdateSingleUser = () => {
  return (
    <div className='update-single-user'>
      <UpdateUser />
    </div>
  );
};

export default UpdateSingleUser;
